import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select } from 'ui/components';

const Filter = ({ show, onClose, JobTable, setCount }) => {
  const handleFilter = async (e) => {
    if (JobTable?.State?.filter) {
      let x = [];
      Object.keys(JobTable?.State?.filter).forEach((k) => {
        if (
          JobTable?.State?.filter[k] &&
          k !== 'origin_name' &&
          k !== 'destination_name' &&
          k !== 'type'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Tipe Layanan</div>
          <Select.Remote
            placeholder=""
            url="/tms/service/type"
            row={(d) => {
              return { value: d?.id, label: d?.name };
            }}
            initialValue={JobTable?.State?.filter?.service_type_id}
            onSelected={(c) => {
              JobTable?.filter('service_type_id', c?.id);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Asal</div>
          <Select.Remote
            placeholder=""
            url="/region/regency"
            initialValue={JobTable?.State?.filter?.origin_id}
            params={{
              search: JobTable?.State?.filter?.origin_name,
            }}
            row={(d) => {
              return {
                value: d.regency_id,
                label: `${d.regency_name}, ${d?.province_name}`,
              };
            }}
            onSelected={(c) => {
              JobTable?.filter('origin_id', c?.regency_id);
              JobTable?.filter('origin_name', c?.regency_name);
              handleFilter();
            }}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Tujuan</div>
          <Select.Remote
            placeholder=""
            url="/region/regency"
            initialValue={JobTable?.State?.filter?.destination_id}
            params={{
              search: JobTable?.State?.filter?.destination_name,
            }}
            row={(d) => {
              return {
                value: d.regency_id,
                label: `${d.regency_name}, ${d?.province_name}`,
              };
            }}
            onSelected={(c) => {
              JobTable?.filter('destination_id', c?.regency_id);
              JobTable?.filter('destination_name', c?.regency_name);
              handleFilter();
            }}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Tipe Layanan
            </div>
            <Select.Remote
              placeholder=""
              url="/tms/service/type"
              row={(d) => {
                return { value: d?.id, label: d?.name };
              }}
              initialValue={JobTable?.State?.filter?.service_type_id}
              onSelected={(c) => {
                JobTable?.filter('service_type_id', c?.id);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Asal</div>
            <Select.Remote
              placeholder=""
              url="/region/regency"
              initialValue={JobTable?.State?.filter?.origin_id}
              params={{
                search: JobTable?.State?.filter?.origin_name,
              }}
              row={(d) => {
                return {
                  value: d.regency_id,
                  label: `${d.regency_name}, ${d?.province_name}`,
                };
              }}
              onSelected={(c) => {
                JobTable?.filter('origin_id', c?.regency_id);
                JobTable?.filter('origin_name', c?.regency_name);
                handleFilter();
              }}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Tujuan</div>
            <Select.Remote
              placeholder=""
              url="/region/regency"
              initialValue={JobTable?.State?.filter?.destination_id}
              params={{
                search: JobTable?.State?.filter?.destination_name,
              }}
              row={(d) => {
                return {
                  value: d.regency_id,
                  label: `${d.regency_name}, ${d?.province_name}`,
                };
              }}
              onSelected={(c) => {
                JobTable?.filter('destination_id', c?.regency_id);
                JobTable?.filter('destination_name', c?.regency_name);
                handleFilter();
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
